// extracted by mini-css-extract-plugin
export default {"table":"Style_table__HXpuZ","thead_wrapper":"Style_thead_wrapper__4SkHo","thead":"Style_thead__ckdA5","tbody":"Style_tbody__SlYe-","th":"Style_th__7Uq7b","td":"Style_td__HyTuV"};